import React, { useContext } from 'react'
import toast from 'react-hot-toast';
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { BsEye } from "react-icons/bs";
import { MdDelete, MdModeEdit } from 'react-icons/md';
import PartnerContext from '../../hooks/PartnerContext';
import { useNavigate } from 'react-router-dom';
import { IoIosInformationCircleOutline, IoMdCheckmark } from 'react-icons/io';




const PartnerCard = ({
    cardKey,
    cardTitleStyle,
    cardTitle,
    cardDetailedDesciption,
    cardParaTestId,
    cardDate,
    imageSource,
    imageClassName,
    width,
    height,
    viewed,
    handleCloseModal,
    handleOpenModal,
    handlePauseModal,
    cardStatus,
    handleJobDelete,
    handleAdFeedback,
    adFeedback,
    setAdFeedback,
    role,
    id,

    remainingDays,
    extendValidityPost,

    handlePartnerRadioButton,
    receiveReferrals,
    referralCount,
    setReferralCount,
    setReceiveReferrals
}) => {

    const { homeApiDataForMapping, setCreateNewAd,
        setReview,
        setPageNumber,
        setRedirectPage,
        setExistingAd,
        setUpdateButton,
        setPdfUrlToBlob,
        setImageUrlToBlob,
        setPdfData, setImageData,
        setUpdatedCardStatus,


        // Pricing
        country
    } = useContext(PartnerContext);


    const pageRender = useNavigate();

    const handleRedirectToPartnerReview = (id) => {
        var redirectingValue = homeApiDataForMapping.filter((v) => {
            return v.learning_id === id
        })

        setImageData([]);
        setPdfData([]);

        if (redirectingValue.length > 0) {
            setCreateNewAd(...redirectingValue)

            var imgg = redirectingValue[0].image
            var splitBySlash = imgg.split("/")
            var splitByDot = imgg.split(".")
            fetch(`https://cdn.2ndcareers.com/${redirectingValue[0].image}`)
                .then((res) => res.blob())
                .then(blob => {
                    const imgfile = new File([blob], splitBySlash[splitBySlash.length - 1], { type: `image/${splitByDot[splitByDot.length - 1]}` })
                    setImageUrlToBlob(imgfile)
                })



            var attached_file = redirectingValue[0].attached_file
            var splitPdfBySlash = attached_file.split("/")
            var splitPdfByDot = attached_file.split(".")
            fetch(`https://cdn.2ndcareers.com/${redirectingValue[0].attached_file}`)
                .then((res) => res.blob())
                .then(blob => {
                    const file = new File([blob], splitPdfBySlash[splitPdfBySlash.length - 1], { type: `application/${splitPdfByDot[splitPdfByDot.length - 1]}` })

                    setPdfUrlToBlob(file)
                })



            setPageNumber(false)
            setReview(true)
            setRedirectPage(true)
            setExistingAd(true)

            pageRender("/partner_dashboard/cardForm")
        } else {
            toast.error("Data not found")
        }
    }

    const handleRedirectToPartnerEditAndReview = (id, cardStatus) => {
        setUpdatedCardStatus(cardStatus)
        var redirectingValue = homeApiDataForMapping.filter((v) => {
            return v.learning_id === id
        })
        if (redirectingValue.length > 0) {
            setCreateNewAd(...redirectingValue)




            var imgg = redirectingValue[0].image
            var splitBySlash = imgg.split("/")
            var splitByDot = imgg.split(".")
            fetch(`https://cdn.2ndcareers.com/${redirectingValue[0].image}`)
                .then((res) => res.blob())
                .then(blob => {
                    const imgfile = new File([blob], splitBySlash[splitBySlash.length - 1], { type: `image/${splitByDot[splitByDot.length - 1]}` })
                    setImageUrlToBlob(imgfile)
                })


            var attached_file = redirectingValue[0].attached_file
            var splitPdfBySlash = attached_file.split("/")
            var splitPdfByDot = attached_file.split(".")
            if (splitPdfBySlash[2] !== '') {
                fetch(`https://cdn.2ndcareers.com/${redirectingValue[0].attached_file}`)
                    .then((res) => res.blob())
                    .then(blob => {
                        const file = new File([blob], splitPdfBySlash[splitPdfBySlash.length - 1], { type: `application/${splitPdfByDot[splitPdfByDot.length - 1]}` })
                        setPdfUrlToBlob(file)
                    })

            }
            else {
                setPdfUrlToBlob({})
                setPdfData([])
            }

            setPageNumber(false)
            setReview(false)
            setRedirectPage(false)
            setUpdateButton(true)
            setExistingAd(true)
            pageRender("/partner_dashboard/cardForm")

        } else {
            toast.error("Data not found")
        }
    }


    const handleButtonDropDown = (drop) => {
        if (drop === "Closed") {
            const closeModal = new bootstrap.Modal(`#closeModal${id}`);
            closeModal.show();
        }

        if (drop === "Open") {
            const openModal = new bootstrap.Modal(`#openModal${id}`);
            openModal.show();
        }

        if (drop === "Paused") {
            const pauseModal = new bootstrap.Modal(`#pauseModal${id}`);
            pauseModal.show();
        }
    };

    const handleModalCancelButton = (e, drop) => {
        setReceiveReferrals("Y")
        setReferralCount(0)
        if (drop === "Close") {
            setAdFeedback('')
        }
    };

    const handleExtendedValidity = () => {
        document.getElementById(`extendedValidity${id}ModalCloseButton`).click()
        pageRender('/partner_dashboard/pricing-plan')
    }

    return (
        <>
            <div
                className="card h-100 shadow-sm bg-body rounded-4 border-0 overflow-hidden"
                key={cardKey}
            >

                <div className="card-body pb-0 p-3">
                    <img
                        src={imageSource}
                        className={imageClassName}
                        alt="Image"
                        data-testid="imgTesting"
                        width={width}
                        height={height}
                    />

                    <div className='py-3'>
                        {role !== 'Review' ? <span className={`card-date-text py-2 mb-0 `}  ><BsEye /> {viewed} Viewed</span> : null}
                    </div>




                    <h6
                        className={`card-title ${cardTitleStyle} fw-semibold pe-3`}
                        data-testid="cardHeadingTestId"
                    >
                        {cardTitle.length > 25 ? `${cardTitle.slice(0, 25)}..` : cardTitle}
                    </h6>

                    {role !== 'Review' ?
                        <p className="cursorPointer partner-threeDotsMenu" aria-expanded="false">
                            {
                                cardStatus !== 'closed' ?
                                    <span id={`partnerHomeEdit${id}Icon`} onClick={() => handleRedirectToPartnerEditAndReview(id, cardStatus)} ><MdModeEdit className='fs-5' /></span>
                                    :
                                    <span id={`partnerHomeDelete${id}Icon`} data-bs-toggle="modal" data-bs-target={`#deleteModal${id}`}><MdDelete className='fs-5' /></span>
                            }
                        </p>

                        :
                        null
                    }
                    {cardDate === "" ? null :
                        <p
                            className={`partner-date-text`}
                            data-testid={cardParaTestId} >Posted on {cardDate} </p>

                    }

                </div>

                <span className="card-description card-text px-3">
                    {`${cardDetailedDesciption.slice(0, 59)}...`}
                </span>
                {role !== 'Review' ?
                    <hr className="mb-2 mt-3 mx-3" />
                    :
                    null
                }

                {/* Two Buttons */}
                {role !== 'Review' ?
                    <div className="card-footer bg-transparent border-0">
                        <div className="d-grid gap-2 d-flex justify-content-center mb-2 mx-1">

                            <div className="dropdown custom-dropdown w-100">
                                {cardStatus !== 'closed' ?
                                    <React.Fragment>
                                        <button
                                            id={`partnerHomeBottomDrop${id}Button`}
                                            className="btn btn-secondary dropdown-toggle rounded-3 me-md-2 ps-3 w-100"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {cardStatus === 'opened' ? 'Open' : cardStatus === 'paused' ? 'Paused' : null}
                                        </button>
                                        <ul className="dropdown-menu border-0 shadow">
                                            {cardStatus !== 'opened' ?
                                                <React.Fragment>
                                                    <li
                                                        onClick={() => {
                                                            handleButtonDropDown("Open");
                                                        }}
                                                    >
                                                        <a className="dropdown-item fw-medium">Open</a>
                                                    </li>
                                                    <hr className="m-0 mx-3 buttonLineColor" />

                                                </React.Fragment>
                                                :
                                                null
                                            }
                                            <li
                                                onClick={() => {
                                                    handleButtonDropDown("Closed");
                                                }}
                                            >
                                                <a className="dropdown-item fw-medium">Close</a>
                                            </li>


                                            {
                                                cardStatus !== 'paused' ?
                                                    <React.Fragment>
                                                        <hr className="m-0 mx-3 buttonLineColor" />
                                                        <li
                                                            onClick={() => {
                                                                handleButtonDropDown("Paused");
                                                            }}
                                                        >
                                                            <a className="dropdown-item fw-medium">Pause</a>
                                                        </li>
                                                    </React.Fragment>

                                                    :
                                                    null
                                            }
                                        </ul>
                                    </React.Fragment>
                                    :
                                    <button
                                        className="btn btn-secondary pe-none dropdown-toggle rounded-3 me-md-2 w-100"
                                        type="button"
                                        aria-expanded="false"
                                    >
                                        Closed
                                    </button>
                                }
                            </div>
                            <div className='w-100'>
                                <button id={`partnerHomeBottomView${id}Button`} className='btn btn-brand-color me-md-2 w-100' onClick={() => handleRedirectToPartnerReview(id)}>View</button>
                            </div>
                        </div>



                        {
                            cardStatus === 'opened' ?

                                <div className="modal-footer border-0 bg-transparent p-0 mx-2 mt-3 mb-2 row align-items-center justify-content-between ">
                                    <div className="col-6 m-0">
                                        {
                                            remainingDays === 0 ?

                                                <span className="w-100 partnerText-Size ad-rejected px-3 rounded">Expired</span>
                                                :

                                                <span className=" w-100 text-secondary partnerText-Size">Remaining Days : {`${remainingDays}`}</span>

                                        }
                                    </div>
                                    <div className="col-6 m-0">
                                        <button type="button" className="btn w-100 btn-outline-secondary partnerText-Size" data-bs-toggle="modal" data-bs-target={`#extendedValidity${id}Modal`}>Extend your validity </button>
                                    </div>

                                </div>

                                :
                                null
                        }


                        {/* Extended Validity  Modal*/}

                        <div className="modal modal-lg fade" id={`extendedValidity${id}Modal`} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog  modal-dialog-centered">
                                <div className="modal-content py-2 px-3">
                                    <div className="modal-header border-0 bg-transparent">
                                        <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">Extend Your Ad Post for an Additional 30 Days!</h1>
                                        <button type="button" id={`extendedValidity${id}ModalCloseButton`} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>

                                    <hr className='m-0 mx-3' />

                                    <div className="modal-body px-3 pt-4 mb-3 w-100">
                                        <div className="jobPost-FontSize text-secondary ps-4">
                                            <span className=""><span className="fs-2 fw-bold text-dark">{country === "India" ? `${process.env.REACT_APP_EXTENDAD_RUPEES}` : `$${process.env.REACT_APP_EXTENDAD_DOLLARS}`}</span>/30days</span>
                                            <p className="pb-3">For {cardTitle}</p>

                                        </div>
                                        <div>
                                            <ul className="jobPost-FontSize mx-2 ps-2">
                                                <li className="list-unstyled mt-4 mb-3">
                                                    <IoMdCheckmark className="mx-2 fs-5  brand-color" /> <span className="fw-bold">Extended Visibility: </span><span>Keep your ad post visible to a wider audience for 30 days</span>
                                                </li>
                                                <li className="list-unstyled mb-3">
                                                    <IoMdCheckmark className="mx-2 fs-5  brand-color" /> <span className="fw-bold">Reach More Candidates: </span><span>Maximize your chances of finding the right fit by keeping you post active</span>
                                                </li>
                                                <li className="list-unstyled mb-4">
                                                    <IoMdCheckmark className="mx-2 fs-5  brand-color" /><span className="fw-bold">Seamless Process: </span><span>Simply make a payment to extend your ad post, and it will remain live without any interruptions</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <span className='jobPost-FontSize text-secondary mx-3 pb-2'><IoIosInformationCircleOutline className='brand-color' /> Enhance your experience by upgrading to our Premium or Platinum plans. <a className='icon-link cursorPointer' onClick={handleExtendedValidity}>click here !</a></span>

                                    <hr className='m-0 mx-3 text-dark' />

                                    <div className="modal-footer border-0 bg-transparent row align-items-center justify-content-between my-3 ">
                                        <div className="col-6 m-0">
                                            <button type="button" className="btn w-100 btn-outline-secondary fw-bold" data-bs-dismiss="modal">Cancel</button>
                                        </div>
                                        <div className="col-6 m-0">
                                            <button type="button" className="btn w-100 btn-brand-color fw-bold" onClick={(e) => extendValidityPost(e, id, `extendedValidity${id}ModalCloseButton`)}>Proceed</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                    :
                    null
                }



                {/* Show more Modal */}
                <div
                    className="modal fade col-md-4"
                    id={`${id}learnMore`}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="ms-2 modal-title learningTitle" id="staticBackdropLabel">
                                    {cardTitle}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body h-100 mb-4 mx-2 card-text">
                                {cardDetailedDesciption}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Open Modal */}
                <div
                    className="modal fade"
                    id={`openModal${id}`}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content p-3">
                            <div className="modal-body">
                                <form>
                                    <div>
                                        <span className="yesOrNoText">
                                            Click submit to open the ad ?
                                        </span>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer border-0 bg-transparent pb-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-brand-color ms-3"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => handleOpenModal(e, id, 'Open')}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Delete Modal */}
                <div
                    className="modal fade"
                    id={`deleteModal${id}`}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content p-3">
                            <div className="modal-body">
                                <form>
                                    <div className="">
                                        <label
                                            htmlFor="recipient-name"
                                            className="col-form-label col"
                                        >
                                            Are you sure you want to delete the ad ?
                                        </label>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer border-0 bg-transparent pb-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-brand-color ms-3"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => handleJobDelete(e, id, 'Delete')}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>



                {/* Pause button Modal*/}
                <div
                    className="modal fade"
                    id={`pauseModal${id}`}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content p-3">
                            <div className="modal-body">
                                <form>
                                    <div className="">
                                        <label
                                            htmlFor="recipient-name"
                                            className="col-form-label col"
                                        >
                                            Are you sure you want to pause the ad ?
                                        </label>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer border-0 bg-transparent pb-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-brand-color ms-3"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => handlePauseModal(e, id, 'Paused')}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Close button Modal */}
                <div
                    className="modal fade"
                    id={`closeModal${id}`}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content p-3">

                            <div className="modal-header border-0">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" id={`closeModal-${id}`} onClick={(e) => handleModalCancelButton(e, 'Close')}></button>
                            </div>

                            <div className="modal-body px-0">
                                <form>
                                    <div className=" row align-items-center w-100">
                                        <div className=" d-flex align-items-center justify-content-between  w-100">
                                            <div className={`textWithRadio col-9`} id={"receiveReferrals"}>
                                                <label htmlFor={"receiveReferrals"} className="col-form-label col">{"Were you able to receive referrals through 2nd Careers ?"}</label>
                                            </div>

                                            <div className="yesOrNo col-3">
                                                <div className="d-flex align-items-center w-100">
                                                    <div className=" col mx-auto flex-fill me-2">
                                                        <input className="form-check-input yesOrNoRadioButtonColor me-1" type="radio" value={"Y"} name={"receiveReferrals"} checked={receiveReferrals === "Y"} id={`roleOne${id}`}
                                                            onChange={(e) => handlePartnerRadioButton(e)} />
                                                        <label className='cursorPointer' htmlFor={`roleOne${id}`}>Yes</label>
                                                    </div>

                                                    <div className=" col mx-auto flex-fill">
                                                        <input className="form-check-input yesOrNoRadioButtonColor me-1" type="radio" value={"N"} name={"receiveReferrals"} checked={receiveReferrals === "N"} id={`roleTwo${id}`}
                                                            onChange={(e) => handlePartnerRadioButton(e)} />
                                                        <label className='cursorPointer' htmlFor={`roleTwo${id}`}>No</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        receiveReferrals === "Y" ?

                                            <div className=" row align-items-center w-100">
                                                <div className='pe-0'>
                                                    <label htmlFor="message-text" className="col-form-label">
                                                        Number of referrals received through 2nd Careers?
                                                    </label>
                                                    <input
                                                        type='number'
                                                        className="form-control"
                                                        id="message-text"
                                                        value={referralCount}
                                                        onChange={(e) => setReferralCount(e.target.value)}
                                                    ></input>
                                                </div>
                                            </div>

                                            :

                                            null
                                    }


                                    <div className=" row align-items-center w-100">
                                        <div className='pe-0'>
                                            <label htmlFor="message-text" className="col-form-label">
                                                Kindly provide your feedback regarding posting this ad through 2nd Careers
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="message-text"
                                                value={adFeedback}
                                                onChange={handleAdFeedback}
                                            ></textarea>
                                        </div>
                                    </div>

                                </form>
                            </div>
                            <div className="modal-footer border-0 bg-transparent pb-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => handleModalCancelButton(e, 'Close')}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-brand-color ms-3"
                                    // data-bs-dismiss="modal"
                                    onClick={(e) =>
                                        handleCloseModal(
                                            e,
                                            receiveReferrals,
                                            adFeedback,
                                            referralCount,
                                            id,
                                            'Closed',
                                        )
                                    }
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PartnerCard